import { render, staticRenderFns } from "./TabCreator.vue?vue&type=template&id=749258ce&scoped=true&"
import script from "./TabCreator.vue?vue&type=script&lang=ts&"
export * from "./TabCreator.vue?vue&type=script&lang=ts&"
import style0 from "./TabCreator.vue?vue&type=style&index=0&id=749258ce&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "749258ce",
  null
  
)

export default component.exports